import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/layer/drift/accept/layer.drift.accept.mutation.gql"
import type {
  LayerDriftAcceptMutation,
  LayerDriftAcceptMutationVariables,
} from "@/v2-backoffice-client/layer/drift/accept/__types__/layer.drift.accept.mutation"

export function useLayerDriftAcceptMutation(
  options?: MutationHookOptions<
    LayerDriftAcceptMutation,
    LayerDriftAcceptMutationVariables
  >,
) {
  return useMutation<
    LayerDriftAcceptMutation,
    LayerDriftAcceptMutationVariables
  >(mutation, options)
}
